// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"221":"xero-callback","548":"result-purchase","809":"users","945":"dashboard"}[chunkId] + "." + {"221":"784db30a6fdf0ca0e082","548":"f69006d7e530ac3bfe1b","809":"6a6216d30169fd7a1491","945":"123ad07463b425209d4a"}[chunkId] + ".js";
};